import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, from, of, switchMap } from 'rxjs';
import { AuthService } from '../auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return from(authService.isValidSession()).pipe(
    switchMap(isValid => {
      return isValid ? of(true) : from(router.navigate(['/login']));
    }),
    catchError(err => {
      console.error('Erreur AuthGuard:', err);
      return from(authService.signOut().then(() => router.navigate(['/login'])));
    })
  );
};
